import React, { Component } from 'react';

import Form from '../../../shared/components/Form';
import PromoCodeInput from '../../../shared/components/PromoCodeInput';
import Button from '../../../shared/components/Button';

class CampaignPromoCodeForm extends Component {
  render(){
    return (
      <div>
        <Form onSubmit={(data) => this.props.onSubmit(data)}>
          <PromoCodeInput 
            name='code' 
            defaultValue={this.props.activePromoCode.code ? this.props.activePromoCode.code : ''}
            placeholder='123ABC' 
            warning={this.props.feedback}
          />
          <Button isSubmit>{this.props.activePromoCode.code ? 'Update' : 'Save'}</Button>
          {/*&nbsp;&nbsp;*/}
          {/*<Button */}
          {/*  onClick={() => this.props.onDismiss()}*/}
          {/*  textColor='#666666'*/}
          {/*  borderColor='#cccccc'*/}
          {/*  backgroundColor='#fff'*/}
          {/*>*/}
          {/*  I don't have a promo code*/}
          {/*</Button>*/}
        </Form>
      </div>
    )
  }
}

export default CampaignPromoCodeForm;


// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/components/CampaignPromoCodeForm.js